import { useNavigate } from 'react-router-dom';

const HomeBlogCard = ({ data }) => {
    const navigate = useNavigate();
    const openBlog = (id) => {
        window.open(`/blog/details/${id}`, '_blank');
    };
    return (
        <>
            {data.map((item, index) => (
                <div key={index} className='blogCard' onClick={() => openBlog(item._id)}>
                    <img alt='trvto_blog' src={item.image} className='blogImage' loading='lazy' decoding='async' />
                    <div className='blogCardTextDiv'>
                        <h3 className='blogCardName'>{item.name}</h3>
                        {/* <p className='blogCardDis'>{item.shortDescription}</p> */}
                    </div>
                </div>
            ))}
            <div className='alignCenter blogViewAll'>
                <button onClick={() => navigate('/blog')} className='readMoreBtn viewAll'>
                    View All
                </button>
            </div>
        </>
    );
};

export default HomeBlogCard;
